import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["$shouldHighlight", "$shouldOffsetRight", "$theme"];
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
// HACK: This weird wrapper is purely to ensure that we don't pass the extra props
// down to the underlying div. If we upgraded styled-components to support either
// transient props or the ignoreProps api we could use that, but sadly our repackage
// does not support it.
const Div = _ref => {
  let rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest));
};
export const getResizeAffordanceWidth = theme => theme.space['250'];
const ResizeAffordance = styled(Div).withConfig({
  displayName: "ResizeAffordance",
  componentId: "asqq4x-0"
})(["border-right-color:", ";border-right-style:solid;border-right-width:", ";background:none;width:", ";height:100%;cursor:col-resize;", " ", " &:hover{border-color:", ";border-right-width:", ";}"], ({
  $theme
}) => $theme.color['border-core-default'], ({
  $theme
}) => $theme.borderWidth['100'], props => getResizeAffordanceWidth(props.$theme), ({
  $shouldOffsetRight,
  $theme
}) => $shouldOffsetRight && css(["right:calc(-", ");position:relative;"], `${$theme.borderWidth['100']} / 2`), ({
  $shouldHighlight,
  $theme
}) => $shouldHighlight ? `border-color: ${$theme.color['fill-info-default']};` : '', ({
  $theme
}) => $theme.color['fill-info-default'], ({
  $theme
}) => $theme.borderWidth['200']);
export default ResizeAffordance;